/* eslint-disable no-param-reassign */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import store from 'src/shared/services/store';

// Tillåt enskilda anrop att hoppa över den globala fel-toasten (t.ex. bakgrundsuppslag
// som postnummer-uppslag, där ett saknat svar inte ska störa användaren).
declare module 'axios' {
  export interface AxiosRequestConfig {
    skipErrorToast?: boolean;
  }
}

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
});

AxiosInstance.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    const token = store.getState().oidc.user?.access_token;
    config.headers = { Authorization: `Bearer ${token}` };
    // ConsoleHelper.log(config.headers);
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  },
);

AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    let errorHandled = false;
    if (!error.response) {
      return Promise.reject('Network Error');
    }

    // Anrop som markerats med skipErrorToast hanterar felet själva (ingen global toast).
    if (originalRequest?.skipErrorToast) {
      return Promise.reject(error.response);
    }

    if (error.response.status === 403) {
      errorHandled = true;
      toast.error(t('common:noPermissionToResource') as string);
      return Promise.reject(error.response);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      errorHandled = true;
      originalRequest._retry = true;
      // console.log('AUTH FAILED');
      // return authService.getNewToken()
      //     .then(token => {
      //         AxiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      //         originalRequest.headers['Authorization'] = 'Bearer ' + token;
      //         return axios(originalRequest);
      //     })
      //     .catch(err => {
      //         console.log('no new token for you sir, please move along!');
      //         store.dispatch(logout());
      //         return Promise.reject(err);
      //     });
      return Promise.reject(error.response);
    }
    // ConsoleHelper.log('server error', error);
    if (!errorHandled) {
      const { data } = error.response;

      let messages: string[] = [];

      if (Array.isArray(data)) {
        // Hanterar: Array av felmeddelanden (t.ex. ["Förnamn är obligatoriskt", ...])
        messages = data;
      } else if (data.title && typeof data.title === 'string' && data.status === 400) {
        // Hanterar: "Problem Details" med title från ValidationError/UserException (400 Bad Request)
        messages = [data.title];
      } else if (data.errors && typeof data.errors === 'object') {
        // Hanterar: "Problem Details" format enligt RFC 7807 / ASP.NET Core (errors: { field: [messages] })
        messages = Object.values(data.errors).flat() as string[];
      } else if (typeof data === 'string') {
        // Hanterar: Enstaka felmeddelande som sträng
        messages = [data];
      } else {
        // Okänt/annat felformat
        messages = ['Ett okänt fel uppstod'];
      }

      messages.forEach((msg) => toast.error(msg));
    }
    // wait what?
    return Promise.reject(error.response);
  },
);

export default AxiosInstance;
